import { difference } from 'lodash';
export var FacilityType;
(function (FacilityType) {
    FacilityType["None"] = "none";
    FacilityType["Tunnel"] = "tunnel";
    FacilityType["Bridge"] = "bridge";
    FacilityType["Culvert"] = "culvert";
    FacilityType["Shed"] = "shed";
    FacilityType["Overpass"] = "overpass";
    FacilityType["Other"] = "other";
})(FacilityType || (FacilityType = {}));
export const FacilityTypes = [
    FacilityType.Tunnel,
    FacilityType.Bridge,
    FacilityType.Culvert,
    FacilityType.Shed,
    FacilityType.Overpass,
    FacilityType.Other,
];
export var FacilityDataSource;
(function (FacilityDataSource) {
    FacilityDataSource["None"] = "none";
    FacilityDataSource["MlitTunnelDb"] = "mlit_tunnel_db";
    FacilityDataSource["MlitBridgeDb"] = "mlit_bridge_db";
    FacilityDataSource["Manual"] = "manual";
})(FacilityDataSource || (FacilityDataSource = {}));
export const FacilityCreateRequestBodyKeys = [
    'facility_name',
    'facility_type',
    'external_id',
    'data_source',
    'route_name',
    'route_classification',
    'kilopost_start',
    'kilopost_end',
    'prefecture_code',
    'municipality_code',
    'address',
    'latitude',
    'longitude',
    'coordinate_system',
    'tunnel_specs',
    'bridge_specs',
    'administrator_name',
    'administrator_code',
    'overall_soundness',
];
export const FacilityUpdateRequestBodyKeys = difference(FacilityCreateRequestBodyKeys, ['facility_type']);
